<template>
  <div id="contenedor-eliminar-contrato-inventario">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Inventario </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar el inventario? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarContratoInventario"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixContratoInventarios from './mixContratoInventarios';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ContratoEliminarInventario',
  mixins: [mixContratoInventarios],
  props: {
    idContrato: {
      type: String,
      required: true,
    },
    contratoInventarioEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
